import React, { useState, useEffect } from "react";
import { Container, Card, Button, Col } from "react-bootstrap";

import instance from "../../../services/api";

const LessonCard = ({ lesson, onCancel }) => {
  const date = new Date(lesson.date);
  const oneHourLater = new Date(date.getTime() + (1*60*60*1000));
  const canCancel = date > new Date(new Date().getTime() + (1*24*60*60*1000));

  return (
    <Card className="my-2">
      <Card.Body>
        <Card.Title className="fw-bold">{lesson.moduleName}</Card.Title>
        <Card.Text className="fw-bold text-muted">
          <span className="ms-3">{date.toDateString()}</span> 
          <span className="ms-5">{date.toLocaleTimeString()}-{oneHourLater.toLocaleTimeString()} AEST (UTC+10)</span>
        </Card.Text>

        { canCancel &&
          <Button variant="primary" className="float-end" onClick={() => onCancel(lesson)}>Cancel</Button>
        }
      </Card.Body>
    </Card>
  );
};
  

const UserLessonsScreen = () => {
  const [upcomingLessons, setUpcomingLessons] = useState([]);
  const [pastLessons, setPastLessons] = useState([]);

    const cancelHandler = async ( lesson ) => {
      if ( !window.confirm("Are you sure you want to cancel this lesson?") ) return;

      if ( lesson.moduleName === "AcLangEDGE Free Consultation" ) {
        await instance.delete("/booking/free-consultation/" + lesson.id).then((response) => {
          if ( response.status !== 200 ) {
            window.alert("Failed to cancel free consultation!");
          } else {
            setUpcomingLessons(upcomingLessons.filter((item) => item.id !== lesson.id));
            window.alert("Free consultation cancelled!");
          }
          
        });
        return;
      } else {
        await instance.delete("/booking/" + lesson.id).then((response) => {
          if ( response.status !== 200 ) {
            window.alert("Failed to cancel lesson!");
          } else {
            setUpcomingLessons(upcomingLessons.filter((item) => item.id !== lesson.id));
            window.alert("Lesson cancelled!");
          }
        });
      }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    
        async function fetchData() {
          await instance.get("/booking/all")
            .then(( response ) => {
              const sortedLessons = response.data.sort((a,b) => new Date(a.date) - new Date(b.date));
              const now = new Date();
              const upcoming = sortedLessons.filter((lesson) => new Date(lesson.date) > now);
              const past = sortedLessons.filter((lesson) => new Date(lesson.date) <= now).reverse();

              setUpcomingLessons(upcoming);
              setPastLessons(past);
            })
            .catch(( err ) => {
              console.error(err);
            })
        }
    
        fetchData();
      }, []);

    return (
        <Container className="page-shell">
          <section className="page-header">
            <h3 className="page-title">My Upcoming Lessons</h3>
            <p className="page-subtitle">Review upcoming lesson times and cancel eligible sessions if needed.</p>
          </section>
          { upcomingLessons.length === 0 && <p>No upcoming lessons.</p> }
          { upcomingLessons.map((lesson, index) => (
            <Col key={index} xs={12}>
              <LessonCard lesson={lesson} onCancel={cancelHandler} />
            </Col>
          )) }

          <section className="page-header mt-4">
            <h3 className="page-title">Past Lessons</h3>
            <p className="page-subtitle">Your completed lesson history.</p>
          </section>
          { pastLessons.length === 0 && <p>No past lessons.</p> }
          { pastLessons.map((lesson, index) => (
            <Col key={`past-${index}`} xs={12}>
              <LessonCard lesson={lesson} onCancel={cancelHandler} />
            </Col>
          )) }
        </Container>
    );
}

export default UserLessonsScreen;